<template>
  <div class="row row--service">
    <!-- DEFAULT VIEW START -->

    <template v-if="view === 'default'">
      <div class="row__name row__name_w156 row__name--service">
        <img :src="approved.service.icon" alt />
        {{ approved.service.title }}
      </div>

      <calendar-day-time>
        <div
          class="line"
          :style="{
            left: _getHoursOffset(line.should_started_at),
            backgroundColor: line.status === 'canceled' ? canceledColor: line.service.color,
            width: _getWidthBlock(line.date_from, line.predicted_time),
            top: getTop(line, index),
          }"
          v-for="(line, index) in approved.requests"
          :key="line.id"
          @click="openOrderModal(line.id)"
        ></div>
      </calendar-day-time>

      <div class="row__stats"></div>
    </template>
    <!-- DEFAULT VIEW END -->

    <!-- EMPLOYEE VIEW START -->
    <template v-if="view == 'employee'">
      <div class="row__name row__name_w156 row__name--service">
        <div class="row--image" :style="{ backgroundImage: 'url(' + executor.small_image + ')' }"></div>
        {{ executor.first_name }} {{ executor.last_name }}
      </div>

      <calendar-day-time>
        <div
          class="line"
          :style="{
            left: _getHoursOffset(line.should_started_at),
            backgroundColor: line.service.color,
            width: _getWidthBlock(line.should_started_at, line.predicted_time),
            top: getTop(line, index),
          }"
          v-for="(line, index) in approved.requests"
          :key="line.id"
          @click="openOrderModal(line.id)"
        ></div>
      </calendar-day-time>

      <div class="row__stats"></div>
    </template>
    <!-- EMPLOYEE VIEW END -->
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import calendarDayTime from '@/components/calendars/day/calendarDayTime'
import calendar from '@/mixins/calendar'

export default {
    name: 'calendar-item-day',
    props: {
        approved: {
            required: true,
        },
        view: {
            required: true,
        },
        detail: {
            required: true,
        },
    },
    mixins: [calendar],
    components: {
        calendarDayTime,
    },
    data() {
        return {
            worker: null,
            onlines: [],
            orders: [],
            master: {
                id: '76161a32-2b60-11ea-aa3b-acde48001122',
                first_name: 'Jeramy',
                last_name: 'Beer',
                small_image:
          'https:/example.com/storage/uploads/masters/small/a74c2933d0615b35cdaebe58e92cfd7e7fb565ec.jpg',
            },
            requests: [
                {
                    request_id: '6fbbf2df-27b3-409c-8c82-7644f85e50e0',
                    schedule_from: '2020-03-20T08:00:00.000000Z',
                    schedule_till: '2020-03-10:10:00.000000Z',
                    fact_from: '2020-03-20T08:45:00.000000Z',
                    fact_till: '2020-03-20T10:25:00.000000Z',
                },
            ],
            shift: {
                time_start: '09:28:43',
                time_end: '15:44:38',
            },
            schedule: {
                time_from: '09:00:00',
                time_till: '18:00:00',
                workday: true,
                from: undefined,
                show: false,
            },
            totalMinutes: 600,
            offestMinutes: 480,
            canceledColor: '#d91717',
        }
    },
    computed: {
        ...mapGetters({
            showDayGetters: 'showDayGetters',
            executor: 'executorGetters',
        }),
    },
    methods: {
        ...mapActions({
            fetchById: 'orders/fetchById',
        }),
        ...mapMutations({
            setToggleModal: 'orders/setToggleModal',
        }),
        getTop(line, index) {
            return `${index * 15 + 5}px`
        },
        async getRequestDetails(id) {
            this.$store.state.calendar.showDetails = false

            this.$Progress.start()
            await this.$store.dispatch('getRequestDetails', id)
            this.$store.state.calendar.showDetails = true
            this.$Progress.finish()
        },
        async openOrderModal(v) {
            await this.fetchById(v)
            this.setToggleModal()
        },
        calculateSchedule() {
            const start = 8

            const p10 = document.querySelectorAll('.row__times')[0].offsetWidth / 10

            if (this.schedule.from !== undefined) {
                return {
                    left: `${(this.schedule.from - start) * p10}px`,
                    width: `${(this.schedule.scheduleWidth + 1) * p10}px`,
                }
            }
        },
        calculateOnline({ from, to }) {
            const p10 = document.querySelectorAll('.row__times')[0].offsetWidth / 10

            return {
                width: `${to * p10}px`,
                left: `${from * p10}px`,
            }
        },
        calculateOrder(item) {
            const p10 = document.querySelectorAll('.row__times')[0].offsetWidth / 10

            return {
                width: `${(item.to - item.from) * p10}px`,
                left: `${(item.from - 1) * p10}px`,
            }
        },
        async prepare(v) {
            if (v === 'services') {
                if (this.approved.executor === undefined) {
                    return
                }

                if (this.approved.executor.requests === undefined) {
                    return
                }

                if (this.approved.executor.requests.length === 0) {
                    return
                }

                this.schedule = this.approved.executor.schedule

                const today = new Date()

                const from = new Date(
                    `${today.getFullYear()}-${today.getMonth() + 1}-${
                        this.detail
                    } 09:00:00`,
                ).getHours()
                const till = new Date(
                    `${today.getFullYear()}-${today.getMonth() + 1}-${
                        this.detail
                    } 19:00:00`,
                ).getHours()
                this.schedule.scheduleWidth = till - from
                this.schedule.from = from

                this.approved.executor.requests.forEach((e) => {
                    this.orders.push({
                        id: e.request_id,
                        from:
              new Date(e.schedule_from).getHours()
              + new Date(e.schedule_from).getMinutes() / 60
              - 8,
                        to:
              new Date(e.schedule_till).getHours()
              + new Date(e.schedule_till).getMinutes() / 60
              - 8,
                        actual_start: new Date(e.fact_from).getMinutes() / 60 - 8,
                        actual_end: new Date(e.fact_till).getMinutes() / 60 - 8,
                    })
                })

                this.schedule.show = true
            }
        },
    },
}
</script>

<style lang="scss" scoped>
// @import "src/assets/sass/main";
// .row {
//   height: 50px;
//   display: flex;
//   border-bottom: solid 1px #f3f3f3;

//   &_header {
//     background-color: rgba(97, 66, 45, 0.05);
//   }

//   &__name {
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     color: rgba(#4d4d4d, 0.5);
//     font-family: $fontMedium;
//     font-size: 16px;
//     max-width: 120px;
//     background-color: #fff;
//     width: 100%;
//     @include respond(desktop) {
//       font-size: 14px;
//     }

//     &--service {
//       position: relative;
//       z-index: 999999999999;
//     }
//   }

//   &__stats {
//     max-width: 290px;
//     min-width: 150px;
//     width: 100%;
//     border-left: 1px solid rgba(77, 77, 77, 0.3);
//     position: relative;
//     z-index: 999999999999;
//     background-color: #fff;
//   }

//   &__times {
//     position: relative;
//     width: 100%;
//     display: flex;

//     & .time {
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       width: calc(100% / 10);
//       color: rgba(#4d4d4d, 0.5);
//       font-family: $fontMedium;
//       font-size: 16px;
//       box-sizing: border-box;
//       min-width: 45px;
//       position: relative;

//       &::before {
//         position: absolute;
//         content: "";
//         border-left: 1px solid rgba(77, 77, 77, 0.3);
//         z-index: 5;
//         height: 100%;
//         left: 0;
//         width: 2px;
//       }

//       @include respond(desktop) {
//         min-width: 39px;
//         font-size: 13px;
//       }

//       &:last-child {
//         &::after {
//           position: absolute;
//           content: "";
//           // border-right: 1px solid rgba(77, 77, 77, 0.5);
//           z-index: 5;
//           height: 100%;
//           right: 0;
//           width: 2px;
//         }
//       }
//     }
//   }

//   &--new {
//     cursor: pointer;

//     & .row__name {
//       justify-content: flex-start;
//       border-top: 1px solid #71bd4a;
//       padding-left: 16px;
//       box-sizing: border-box;
//       color: #4d4d4d;
//       font-size: 10px;

//       & img {
//         margin-right: 10px;
//         width: 24px;
//       }
//     }

//     & .time span {
//       display: block;
//       width: 100%;
//       height: 100%;
//       background-color: rgba(#71bd4a, 0.1);
//     }

//     & .request {
//       position: absolute;
//       top: 9px;
//       height: 30px;
//       border-radius: 8px;
//       box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
//       background-color: #71bd4a;
//       color: #ffffff;
//       font-size: 12px;
//       font-family: $fontBold;
//       display: flex;
//       justify-content: center;
//       align-items: center;
//       text-align: center;
//       width: 40px;
//     }
//   }

//   &--service {
//     height: auto;
//     min-height: 80px;

//     & .row__name {
//       border-top: 1px solid #979797;
//       justify-content: flex-start;
//       padding-left: 16px;
//       box-sizing: border-box;
//       color: #4d4d4d;
//       font-size: 10px;

//       & img {
//         margin-right: 10px;
//         width: 24px;
//       }
//     }

//     & .line {
//       position: absolute;
//       display: inline-block;
//       z-index: 9999999;
//       height: 7px;
//       cursor: pointer;
//       transition: 0.5s;

//       &:hover {
//         transform: scale(1.05);
//         height: 7px;
//       }
//     }
//   }

//   &--image {
//     width: 30px;
//     height: 30px;
//     border: solid 1px $secondColor;
//     background-size: cover;
//     background-position: center;
//     border-radius: 50%;
//     margin-right: 10px;
//     flex-shrink: 0;
//   }
// }
// .row {
//   &__stats {
//     max-width: 290px;
//     min-width: 150px;
//     width: 100%;
//   }
// }

// .master {
//   &-schedule {
//     width: 100%;
//     width: 100%;
//     height: 47px;
//     background-color: rgba(155, 205, 130, 0.3);
//     position: absolute;
//     left: 0;
//     top: calc(50% - 23.5px);
//   }

//   &-online {
//     background-color: #502d8c;
//     position: absolute;
//     height: 2px;
//     bottom: 0;
//     z-index: 2;
//   }

//   &-order {
//     background-color: #beb4dc;
//     position: absolute;
//     height: 100%;
//     z-index: 1;

//     &__actual {
//       background-color: rgba(#50af3c, 0.9);
//       width: 100%;
//       height: inherit;
//     }

//     &__late {
//       // height: inherit;
//       // top: 0;
//       // left: -20px;
//       // width: 20px;
//       // z-index: 3;
//       // position: absolute;
//       // background-color: #E64B23;
//     }
//   }
// }
</style>
